export default "__VITE_ASSET__21f7a2b4__"